import { Languages } from "lucide-react"
import { useLanguage } from "../i18n/LanguageContext"

export default function LanguageSwitcher({ compact = false, className = "" }) {
  const { isRTL, t, toggleLanguage } = useLanguage()
  const label = isRTL ? t("common.english") : t("common.arabic")

  return (
    <button
      type="button"
      onClick={toggleLanguage}
      className={`language-switcher ${compact ? "language-switcher-compact" : ""} ${className}`.trim()}
      aria-label={isRTL ? t("common.switchToEnglish") : t("common.switchToArabic")}
      title={isRTL ? t("common.switchToEnglish") : t("common.switchToArabic")}
    >
      <Languages className="language-switcher-icon" aria-hidden="true" />
      <span>{label}</span>
    </button>
  )
}

